import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {
    Card,
    Form,
    HyperLink,
    InputBox,
    notification,
} from "../../components/Elements/appUtils";
import _ from "lodash";
// import { category } from "../../components/_utils/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {Boolean, vegNonVeg} from "../../components/_utils/_utils";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {getMainMenuUrl} from "../mainmenu/api";
import {getMainCategoryUrl} from "../maincategory/api";
import {appAxios as axios} from "../../request";
import {getToken} from "../../request";
// import { FetchBrand, addProductFxn, getCategory } from "./actions";

import {fetchCategory} from "../categories/actions";
import {FetchCatgory, FetchVariants} from "../variants/actions";
import {addProductFxn} from "./actions";
import Modal from "../../components/Elements/Modal";

// import { getItemLocalstorage } from "../../components/_utils/_utils";

function AddProduct(props) {
    const [formData, setFormData] = useState([
        {variantId: "", price: "", name: ""},
    ]);
    console.log(formData, "formdata");

    const [productFile, setproductFile] = useState("");
    const [mainCategoryIndex, setMainCategoryIndex] = useState("");
    const [categoryIndex, setCategoryIndex] = useState("");
    const [mainCategory, setMainCategory] = useState("");
    const [showDeleteButtons, setShowDeleteButtons] = useState([false]);
    const [variantModalVisible, setVariantModalVisible] = useState(false);
    const handleFileChange = (e) => {
        const file = e.files[0];
        setproductFile(file);
    };
    const handleInputChange = (index, field, value) => {
        const newData = [...formData];
        newData[index][field] = value;
        setFormData(newData);
        setShowDeleteButtons((prevButtons) =>
            prevButtons?.map((btn, idx) => (idx === index ? true : btn)),
        );
    };

    const handleDelete = (index) => {
        const newPayments = [...formData];
        newPayments.splice(index, 1);
        setFormData(newPayments);
        setShowDeleteButtons((prevButtons) =>
            prevButtons?.filter((_, idx) => idx !== index),
        );
    };

    const handleAddField = () => {
        const lastData = formData[formData.length - 1];
        if (!lastData.variantId) {
            notification.warning({message: "Please Choose Variant"});
            return;
        }
        if (!lastData.price) {
            notification.warning({message: "Please Enter Price"});
            return;
        }

        setFormData([...formData, {variantId: "", price: "", name: ""}]);

        setShowDeleteButtons([...showDeleteButtons, true]);
    };
    const handleVariantModalClose = () => {
        setVariantModalVisible(false);
    };

    const handleVariantModalSave = () => {
        const filledRows = formData.filter(
            (row) => row.variantId || row.price || row.name
        );

        for (let i = 0; i < filledRows.length; i++) {
            if (!filledRows[i].variantId) {
                notification.warning({message: `Please Choose Variant in row ${i + 1}`});
                return;
            }

            if (!filledRows[i].price) {
                notification.warning({message: `Please Enter Price in row ${i + 1}`});
                return;
            }
        }

        setVariantModalVisible(false);
    };
    //   const userType = getItemLocalstorage("user")["userType"];
    const {getFieldValue} = props.form;
    // let { onClose = null } = props;
    let {onClose = null, isEmbedded = false} = props;

    let dispatch = useDispatch();
    const navigate = useNavigate();
    const [category2, setCategory2] = useState([]);
    const [oldSubCategory, setOldSubCategory] = useState([]);
    const [variant, setVariant] = useState([]);
    const [mainMenus, setMainMenus] = useState([]);
    const [mainCategories, setMainCategories] = useState([]);
    const [dynamicMainCategories, setDynamicMainCategories] = useState([]);

    // const api = async () => {
    //   let x = await FetchCatgory({ results: 500 });
    //   setCategory2(x.data);
    //   setOldSubCategory(x.data);
    // };

    //   const api = async () => {
    //   let x = await FetchCatgory({
    //     results: 500,
    //     deleted: { $ne: true },
    //   });

    //   setCategory2(x.data);
    //   setOldSubCategory(x.data);

    //   // Extract unique menus
    //   const menus = _.uniqBy(x.data, "menu");
    //   setMainMenus(menus);
    // };
    const api = async () => {
        let x = await FetchCatgory({
            results: 500,
            deleted: {$ne: true},
        });

        setCategory2(x.data);
        setOldSubCategory(x.data);
    };

    const getMainMenus = async () => {
        try {
            const res = await axios.get(getMainMenuUrl(), getToken());

            if (res.data.success) {
                setMainMenus(res.data.data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    const loadDynamicMainCategories = async () => {
        try {
            const res = await axios.get(getMainCategoryUrl(), getToken());

            if (res.data.success) {
                const filtered = (res.data.data || []).filter(
                    (item) => item.deleted !== true,
                );
                setDynamicMainCategories(filtered);
            }
        } catch (err) {
            console.log(err);
        }
    };

    // const getVariant = async (params) => {
    //   if (getFieldValue("categoryId")) {
    //     const { data } = await FetchVariants({
    //       category: getFieldValue("categoryId"),
    //       results: 100,
    //       count: 100,
    //     });
    //     setVariant(data.data);
    //   } else {
    //     setVariant([]);
    //   }
    // };

    const getVariant = async () => {
        const {data} = await FetchVariants({
            results: 100,
            count: 100,
        });

        setVariant(data.data || []);
    };
    useEffect(() => {
        api();
        getMainMenus();
        loadDynamicMainCategories();
    }, []);

    const handleSubmit = async (e) => {
        const {form} = props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {
            if (!err) {
                if (!valData.name) {
                    notification.warning({message: "Enter Name"});
                    return;
                }
                if (!valData.categoryId) {
                    notification.warning({message: "Choose Category"});
                    return;
                }
                if (!valData.code) {
                    notification.warning({message: "Enter Code"});
                    return;
                }
                if (valData.price === undefined || valData.price === null || valData.price === "") {
                    notification.warning({ message: "Enter Price" });
                    return;
                }

                if (Number(valData.price) <= 0) {
                    notification.warning({ message: "Price must be greater than 0" });
                    return;
                }
                // if (!valData.vegNonVeg) {
                //   notification.warning({ message: "Choose Veg/Non-Veg" });
                //   return;
                // }
                if (!valData.vegNonVeg) {
                    notification.warning({message: "Choose Veg/Non-Veg"});
                    return;
                }
                const selectedCategory = _.find(category2, (item) => {
                    return item._id == valData.categoryId;
                });

// console.log("SELECTED CATEGORY =>", selectedCategory);

                if (selectedCategory) {
                    valData.menu =
                        selectedCategory.mainMenuId?.mainMenuName ||
                        valData.menu ||
                        "";

                    valData.mainMenuId =
                        selectedCategory.mainMenuId?._id ||
                        valData.mainMenuId ||
                        "";

                    valData.mainCategory =
                        selectedCategory.mainCategoryId?.mainCategoryName ||
                        valData.mainCategory ||
                        "";

                    valData.mainCategoryId =
                        selectedCategory.mainCategoryId?._id ||
                        selectedCategory.mainCategoryId ||
                        "";
                }

// console.log("FINAL PRODUCT DATA BEFORE SAVE =>", valData);
//   valData.variants = formData;
//      valData.variants = isEmbedded ? [] : formData;
//      valData.variants = formData;

                const cleanedVariants = formData.filter(
                    (row) => row.variantId || row.price || row.name
                );

                for (let i = 0; i < cleanedVariants.length; i++) {
                    if (!cleanedVariants[i].variantId) {
                        notification.warning({message: `Please Choose Variant in row ${i + 1}`});
                        return;
                    }

                    if (!cleanedVariants[i].price) {
                        notification.warning({message: `Please Enter Price in row ${i + 1}`});
                        return;
                    }
                }

                valData.variants = cleanedVariants;
                valData.mainCategoryIndex = mainCategoryIndex;
                valData.categoryIndex = categoryIndex;
// console.log("SELECTED CATEGORY =>", selectedCategory);
                let fd = new FormData();
                fd.append("obj", JSON.stringify(valData));

                if (productFile && productFile.name) {
                    fd.append("productFile", productFile);
                }

                let x = await dispatch(addProductFxn(fd));
                if (x && x.success) {
                    props.form.setFieldsValue({});
                    // if (onClose) {
                    //   window.location.reload();
                    //   onClose();
                    // }

                    if (onClose) {
                        onClose();
                    }
                    // props.form.setFieldsValue({
                    //   name: "",
                    //   categoryId: "",
                    //   code: "",
                    //   price: "",
                    //   menu: "",
                    //   mainMenuId: "",
                    // });
                    props.form.setFieldsValue({
                        name: "",
                        categoryId: "",
                        code: "",
                        price: "",
                        menu: "",
                        mainMenuId: "",
                        mainCategoryId: "",
                        mainCategory: "",
                    });
                    // setFormData([]);
                    setFormData([{variantId: "", price: "", name: ""}]);
                    setShowDeleteButtons([false]);
                    //
                    // setTimeout(() => {
                    //   navigate("/productList");
                    // }, 1000);
                    // if (isEmbedded) {
                    //   window.location.reload();
                    // } else {
                    //   setTimeout(() => {
                    //     navigate("/productList");
                    //   }, 1000);
                    // }
                    if (!isEmbedded) {
                        setTimeout(() => {
                            navigate("/productList");
                        }, 1000);
                    }
                }
            }
        });
    };
    // useEffect(() => {
    //   let subcategory = category2.filter((item) => {
    //     return item.menu == getFieldValue("menu");
    //   });
    //   if (subcategory) {
    //     setCategory2(subcategory);
    //   }
    // }, [getFieldValue("menu")]);
    // useEffect(() => {
    //   const selectedMenu = getFieldValue("menu");

    //   if (!selectedMenu) {
    //     setCategory2(oldSubCategory);
    //     return;
    //   }

    //   const subcategory = oldSubCategory.filter((item) => {
    //     const staticMatch = item.menu === selectedMenu;

    //     const dynamicMatch =
    //       item.mainCategoryId?.mainCategoryName === selectedMenu ||
    //       item.mainCategoryName === selectedMenu;

    //     return staticMatch || dynamicMatch;
    //   });

    //   console.log("SELECTED MAIN CATEGORY =>", selectedMenu);
    //   console.log("FILTERED CATEGORY LIST =>", subcategory);

    //   setCategory2(subcategory);
    // }, [getFieldValue("menu"), oldSubCategory]);

    // useEffect(() => {
    //   const selectedMenu = getFieldValue("menu");

    //   if (!selectedMenu) {
    //     setCategory2(oldSubCategory);
    //     return;
    //   }

    //   const normalize = (val) =>
    //     String(val || "")
    //       .trim()
    //       .toLowerCase();

    //   const subcategory = oldSubCategory.filter((item) => {
    //     const selected = normalize(selectedMenu);

    //     const staticMatch = normalize(item.menu) === selected;

    //     const dynamicMatch =
    //       normalize(item.mainCategoryId?.mainCategoryName) === selected ||
    //       normalize(item.mainCategoryName) === selected ||
    //       normalize(item.mainCategory) === selected;

    //     return staticMatch || dynamicMatch;
    //   });

    //   // console.log("SELECTED MAIN CATEGORY =>", selectedMenu);
    //   // console.log("FILTERED CATEGORY LIST =>", subcategory);

    //   setCategory2(subcategory);
    // }, [getFieldValue("menu"), oldSubCategory]);
    useEffect(() => {
        const selectedMainCategoryId = getFieldValue("mainCategoryId");

        if (!selectedMainCategoryId) {
            setCategory2([]);
            return;
        }

        const filteredCategories = oldSubCategory.filter((item) => {
            return (
                String(item.mainCategoryId?._id || item.mainCategoryId) ===
                String(selectedMainCategoryId)
            );
        });

        setCategory2(filteredCategories);
    }, [getFieldValue("mainCategoryId"), oldSubCategory]);

    // useEffect(() => {
    //   getVariant();
    // }, [getFieldValue("categoryId")]);
    useEffect(() => {
        getVariant();
    }, []);

    const mergedMainCategories = dynamicMainCategories.map((item) => ({
        ...item,
        source: "dynamic",
        value: item._id,
        label: item.mainCategoryName,
    }));
    const filteredMainCategories = mergedMainCategories.filter((item) => {
        const selectedMainMenuId = getFieldValue("mainMenuId");

        if (!selectedMainMenuId) return false;

        return String(item.mainMenuId?._id || item.mainMenuId) === String(selectedMainMenuId);
    });

    let inputTypes = {
        fields: [
            {
                key: "mainMenuId",
                label: "Main Menu",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                type: "select",
                options: mainMenus,
                showSearch: true,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => x.mainMenuName.toUpperCase(),
                // onChange: (value) => {
                //   props.form.setFieldsValue({
                //     mainMenuId: value,
                //   });
                // },
                onChange: (value) => {
                    props.form.setFieldsValue({
                        mainMenuId: value,
                        mainCategoryId: "",
                        categoryId: "",
                    });
                    setCategory2([]);
                },
            },
            {
                key: "mainCategoryId",
                label: "Main Category",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                type: "select",
                // options: mergedMainCategories,
                options: filteredMainCategories,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => `${x.label}`,
                // onChange: (selectedOption) => {
                //   const findIndex = _.find(mergedMainCategories, (item) => {
                //     return item._id === selectedOption;
                //   });

                //   if (!findIndex) return;

                //   setMainCategoryIndex(findIndex.index || "");
                //   props.form.setFieldsValue({
                //     menu: selectedOption,
                //     mainCategoryIndex: findIndex.index || "",
                //     categoryId: "",
                //     mainCategoryId: selectedOption,
                //   });

                //   setCategory2(oldSubCategory);
                // },
                onChange: (selectedOption) => {
                    const findIndex = _.find(mergedMainCategories, (item) => {
                        return String(item._id) === String(selectedOption);
                    });

                    if (!findIndex) return;

                    setMainCategoryIndex(findIndex.index || "");
                    props.form.setFieldsValue({
                        mainCategoryIndex: findIndex.index || "",
                        categoryId: "",
                        mainCategoryId: selectedOption,
                    });
                },
            },
            //       {
            //   key: "mainMenu",
            //   label: "Main Menu",
            //   span: "col-md-4",
            //   type: "select",
            //   options: mainMenus,
            //   keyAccessor: (x) => x.menu,
            //   valueAccessor: (x) => `${x.menu}`,
            //   onChange: (value) => {

            //     const filteredMainCategory = oldSubCategory.filter((item) => {
            //       return item.menu === value;
            //     });

            //     setMainCategories(filteredMainCategory);

            //     props.form.setFieldsValue({
            //       mainMenu: value,
            //       menu: "",
            //       categoryId: "",
            //     });

            //   },
            // },
            {
                key: "categoryId",
                label: "Select Category *",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                // placeholder: "Categories",
                type: "select",
                options: category2,
                showSearch: true,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => `${x.name}`,

                // onChange: (selectedOption) => {
                //   let findIndex = _.find(category2, (item) => {
                //     return item._id == selectedOption;
                //   });

                //   if (!findIndex) return;

                //   setMainCategoryIndex(findIndex.mainCategoryIndex || "");
                //   setCategoryIndex(findIndex.index || "");
                //   setMainCategory(findIndex.menu || "");

                //   props.form.setFieldsValue({
                //     categoryId: selectedOption,
                //     mainCategoryIndex: findIndex.mainCategoryIndex || "",
                //     mainCategory: findIndex.menu || "",
                //   });
                // },
                onChange: (selectedOption) => {
                    let selectedCategory = _.find(category2, (item) => {
                        return item._id == selectedOption;
                    });

                    if (!selectedCategory) return;

                    const resolvedMainCategoryName =
                        selectedCategory.mainCategoryId?.mainCategoryName || "";

                    const resolvedMainMenuId =
                        selectedCategory.mainMenuId?._id ||
                        getFieldValue("mainMenuId") ||
                        "";

                    setMainCategoryIndex(selectedCategory.mainCategoryIndex || "");
                    setCategoryIndex(selectedCategory.index || "");
                    setMainCategory(resolvedMainCategoryName);

                    props.form.setFieldsValue({
                        categoryId: selectedOption,
                        mainCategoryIndex: selectedCategory.mainCategoryIndex || "",
                        mainCategory: resolvedMainCategoryName,
                        mainMenuId: resolvedMainMenuId,
                    });
                },
            },
            {
                key: "name",
                label: "Name *",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                // placeholder: "Name",
            },
            {
                key: "description",
                label: "Description",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                type: "textarea",
            },


            {
                key: "code",
                label: "Code *",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                // placeholder: "Product Code",
            },
            {
                key: "price",
                label: "Price *",
                type: "number",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                // placeholder: "Price",
                hidden: getFieldValue("type") === "Product",
            },
            {
                key: "vegNonVeg",
                label: "Veg/Non-Veg/Egg*",
                // span: "col-md-4",
                span: isEmbedded ? "col-md-3" : "col-md-4",
                type: "select",
                hidden: false,
                options: vegNonVeg,
                showSearch: true,
                keyAccessor: (x) => x.name,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        vegNonVeg: x,
                    });
                },
                // required: true,
            },

            {
                key: "productFile",
                label: "Product File",
                required: false,
                type: "file",
                hidden: isEmbedded,
                fileName: productFile,
                onChange: ({target}) => {
                    handleFileChange(target);
                },
                span: "col-md-4",
            },
        ],
    };

    // return (
    //   <PageHeader title={"Add Product"}>

    const formDiv = (
        <Form onSubmit={handleSubmit}>
            <div className="form-elements-wrapper">
                <div>
                    {/*<div className={"row"}>*/}
                    {/*  {inputTypes.fields.map((item, key) => {*/}
                    {/*    return !item.hidden ? (*/}
                    {/*      <div*/}
                    {/*        className={`${item.span ? item.span : "col-md-6"}`}*/}
                    {/*        key={key}*/}
                    {/*      >*/}
                    {/*        /!* <GetEachFormFields {...props.form} item={item} /> *!/*/}
                    {/*        <GetEachFormFields {...props.form} item={{ ...item }} />*/}
                    {/*      </div>*/}
                    {/*    ) : null;*/}
                    {/*  })}*/}
                    {/*</div>*/}
                    <div className={"row"}>
                        {inputTypes.fields.map((item, key) => {
                            return !item.hidden ? (
                                <div
                                    className={`${item.span ? item.span : "col-md-6"}`}
                                    key={key}
                                >
                                    <GetEachFormFields {...props.form} item={{...item}}/>
                                </div>
                            ) : null;
                        })}
                        {isEmbedded && (
                            <div
                                className="col-md-3 d-flex align-items-center"
                                style={{marginTop: "-8px"}}
                            >
                                <div className="d-flex gap-2 w-100">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => setVariantModalVisible(true)}
                                    >
                                        Add Variants
                                    </button>

                                    <button type="submit" className="btn btn-primary">
                                        Submit
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => {
                                            props.form.setFieldsValue({
                                                name: "",
                                                categoryId: "",
                                                code: "",
                                                price: "",
                                                menu: "",
                                                mainMenuId: "",
                                                mainCategoryId: "",
                                                mainCategory: "",
                                                description: "",
                                            });
                                            setCategory2([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}

                    </div>
                    <Modal
                        title="Add Variants"
                        visible={variantModalVisible}
                        onClose={handleVariantModalClose}
                        width={900}
                        className="product-variant-modal"
                    >
                        <div>
                            {formData?.map((data, index) => (
                                <div key={index} className={"row"}>
                                    <div className={"col-md-5"}>
                                        <InputBox title={"Variants"}>
                                            <select
                                                className="form-control"
                                                value={data.variantId}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    if (!value) {
                                                        handleInputChange(index, "variantId", "");
                                                        handleInputChange(index, "name", "");
                                                        return;
                                                    }

                                                    const parsed = JSON.parse(value);
                                                    handleInputChange(index, "variantId", parsed._id);
                                                    handleInputChange(index, "name", parsed.name);
                                                }}
                                            >
                                                <option value="">
                                                    {data.variantId ? ` ${data.name}` : "Select Variant"}
                                                </option>

                                                {variant?.map((item) => (
                                                    <option key={item._id} value={JSON.stringify(item)}>
                                                        {item.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </InputBox>
                                    </div>

                                    <div className={"col-md-4"}>
                                        <InputBox title={"Price"}>
                                            <input
                                                className={"form-control"}
                                                type="number"
                                                value={data.price}
                                                onChange={(e) =>
                                                    handleInputChange(index, "price", e.target.value)
                                                }
                                                placeholder="Amount"
                                            />
                                        </InputBox>
                                    </div>

                                    <div className={"col-md-3"}>
                                        <InputBox className="deleteBtn">
                                            <div className={"item-flex margin-variant"}>
                                                {index > 0 && showDeleteButtons[index] && (
                                                    <a
                                                        className="empty_btn"
                                                        onClick={() => handleDelete(index)}
                                                    >
                                                        <i className="fa fa-trash-alt"></i>
                                                    </a>
                                                )}
                                            </div>
                                        </InputBox>
                                    </div>
                                </div>
                            ))}

                            <div>
                                <InputBox className={"pb-2"}>
                                    <a className="addBtn btn-link" onClick={handleAddField}>
                                        Add More
                                    </a>
                                </InputBox>
                            </div>

                            <div className="mt-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleVariantModalSave}
                                >
                                    Save Variants
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-danger ms-2"
                                    onClick={handleVariantModalClose}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>


            {!isEmbedded && (
                <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setVariantModalVisible(true)}
                    >
                        Add Variants
                    </button>

                    <button type="submit" className="btn btn-primary ms-2">
                        Submit
                    </button>

                    <HyperLink className="ms-2 btn btn-danger" link={"/productlist"}>
                        Cancel
                    </HyperLink>
                </>
            )}
        </Form>

    )
    return (
        <PageHeader title={isEmbedded ? "" : "Add Product"}>
            {isEmbedded ? formDiv :
                <Card>
                    {formDiv}
                </Card>}
        </PageHeader>
    );
}

export default Form.create()(AddProduct);
